// TODO: check if it is used. It could be not used after Warehouse new backend refactoring
export var PackingType;
(function (PackingType) {
    PackingType[PackingType["None"] = 0] = "None";
    /** Former `CLIENT` (old frontend). */
    PackingType[PackingType["Sale"] = 1] = "Sale";
    PackingType[PackingType["Return"] = 2] = "Return";
    PackingType[PackingType["ToStock"] = 3] = "ToStock";
})(PackingType || (PackingType = {}));
